<template>
  <div>
    <add-deposit-type
      :is-active.sync="isDepositModalOpen"
      @changed="onSuccessfullSubmit"
      :paymentType="{ country_id: 1 }"
      @on-fail="onFail"
    />
    <data-table
      title="Payin Transacations"
      :url="url"
      :headers="headers"
      :fields="fields"
      ref="table"
      searchable
      :archive="true"
      :dateSort="true"
      :csv="true"
      csvFileName="cashouts.csv"
      :csvFields="csvFields"
      @date-range-updated="(url) => (this.url = url)"
      @update-archived="(status) => (this.showArchived = status)"
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template #action.icons>
        <div class="d-flex justify-center items-center">
          <v-btn color="primary" @click="isDepositModalOpen = true" class="mr-3">
            <v-icon color="light-blue lighten-4">
              mdi-plus-outline
            </v-icon>
            Make a deposit
          </v-btn>
          <v-select
            label="Transaction Status"
            dense
            v-model="status"
            solo
            filled
            clearable
            :items="[
              { text: 'Pending', value: 'pending' },
              { text: 'Started', value: 'started' },
              { text: 'Error', value: 'error' },
              { text: 'Completed', value: 'completed' },
            ]"
          ></v-select>
        </div>
      </template>

      <template slot="item.status" slot-scope="{ item }">
        <v-icon color="success" v-if="item.status === 'completed'"> mdi-progress-check </v-icon>
        <v-icon color="grey" v-else-if="item.status === 'pending'"> mdi-progress-alert </v-icon>
        <v-icon color="primary" v-else-if="item.status === 'started'"> mdi-progress-clock </v-icon>
        <v-icon color="error" v-else-if="item.status === 'error'"> mdi-progress-close </v-icon>
      </template>
    </data-table>
  </div>
</template>
<script>
import AddDepositType from "./form";

export default {
  components: { AddDepositType },
  data() {
    return {
      isDepositModalOpen: false,
      status: "",
      url: "api/v1/cashin",
      showArchived: false,
      headers: {
        created_at: "Date (created at)",
        started_at: "Started At",
        "source_user.full_name": "Recipient full name",
        "destination_user.full_name": "Distributor full name",
        amount_without_fee: "Amount (Euro)",
        local_amount_without_fee: "Amount (local currency)",
      },
      fields: {
        created_at: {
          type: "date",
        },
        started_at: {
          type: "date",
        },
        amount_in_danacoin: {
          type: "currency",
        },
        local_amount_without_fee: {
          format: (value, item) => {
            return `${this.asCurrency(item.local_amount_without_fee)} ${item.local_currency}`;
          },
        },
        amount_without_fee: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
      },
      csvFields: [
        {
          label: "Recipient User",
          value: "source_user.full_name",
          default: "",
        },
        {
          label: "Distributor Name",
          value: "destination_user.full_name",
          default: "",
        },
        {
          label: "Amount (EUR)",
          value: "amount_without_fee",
          default: "",
        },
        {
          label: "Amount (Local Currency)",
          value: "local_amount_without_fees",
          default: "",
        },
        {
          label: "Started At",
          value: "started_at",
          default: "",
        },
      ],
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
    status(val) {
      let data = { name: "status", value: "" };
      if (val) {
        data = { name: "status", value: val };
      }
      const params = this.$refs.table.addParams(this.url, [data]);
      this.url = `/api/v1/cashin?${params}`;
    },
    showArchived: function (val) {
      const params = this.$refs.table.addParams(this.url, []);
      if (val) {
        this.url = `/api/v1/cashin/all?${params}`;
      } else {
        this.url = `/api/v1/cashin?${params}`;
      }
    },
  },
  methods: {
    showDetails({ id }) {
      this.$router.push({ name: "payins.show", params: { id } });
    },
    onFail() {
      this.isDepositModalOpen = false;
    },
    onSuccessfullSubmit(response) {
      this.isDepositModalOpen = false;
      window.Notify.success(response.message);
      this.$refs.table.fetchData();
    },
  },
};
</script>
